import React, { useEffect, useState } from "react";
import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import dropdownArrow from "../../../../images/gilead- collapse-dropdown.svg";
import DisabledBackArrowicon from "../../../../images/gilead- collapse-dropdown.svg";
import "./dropdown.scss";

const CommonAutocompleteDropdown = (props) => {
  const {
    options,
    disableValue,
    label,
    required,
    renderOption,
    renderTag,
    onChange,
    value,
  } = props;
  const [currentValue, setCurrentValue] = useState(value);
  /* useEffect(() => {
    console.log("rendereed", value)
    setCurrentValue(value)
    return () => {
        
      }
    }, []) */
  return (
    <Autocomplete
      //open={true}
      disablePortal
      disableClearable
      id="combo-box-demo-dropdown"
      className={`autocomplete-dropdown-custom ${
        disableValue ? "desabled-modular-id" : ""
      }`}
      popupIcon={
        <img
          src={options.length < 1 ? DisabledBackArrowicon : dropdownArrow}
          width={13}
          height={8}
          alt=""
        />
      }
      options={options}
      onChange={(e, newValue) => onChange(e, newValue, label)}
      value={value !== undefined ? value : ""}
      disable={disableValue}
      fullWidth={true}
      size="small"
      sx={{
        "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
          fontSize: "12px",
          // transformOrigin: "top",
          color: "#66676b",
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <span>
              {label} {required ? <span className="required">*</span> : ""}
            </span>
          }
          name={label}
          InputProps={{
            ...params.InputProps,
            //startAdornment: (label==="Modular Project ID" && value ?<img src={successIcon} style={{marginTop: '14px',height: '12px',width: '12px', marginLeft: '7px'}}/>:''),
          }}
        />
      )}
      renderOption={renderOption}

      //  renderTags={renderTag}
    />
  );
};

export default CommonAutocompleteDropdown;
